import React from 'react';

// For passing values according to which the message is set to the user or setting of spinner display.
// This is the 'Context API', which allows us to pass values to multiple nested components without having to pass through props.
export const QuizContext = React.createContext(undefined);
